import { jsx as _jsx } from "react/jsx-runtime";
import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import React, { useMemo } from "react";
import { getMetaDescription } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/__internal__/utils";
import { useLoggedOutCategoryPageBrandTileReviewsResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageBrandTileReviewsResponse";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
import { useLoggedOutCategoryPagePrevAndNextPageNumber } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/usePrevAndNextPageNumber";
export var LoggedOutCategoryPageHelmet = function() {
    var seoCategoryText = useLoggedOutCategoryPageMetaTags().seoCategoryText;
    var _ref = seoCategoryText !== null && seoCategoryText !== void 0 ? seoCategoryText : {}, title = _ref.title, meta_description = _ref.meta_description;
    var brandsWithReview = useLoggedOutCategoryPageBrandTileReviewsResponse();
    var prevAndNextPageNumber = useLoggedOutCategoryPagePrevAndNextPageNumber();
    var description = useMemo(function() {
        return getMetaDescription(brandsWithReview, meta_description);
    }, [
        brandsWithReview,
        meta_description
    ]);
    return /*#__PURE__*/ _jsx(FaireHelmet, {
        title: title,
        description: description,
        prev: prevAndNextPageNumber.prev,
        next: prevAndNextPageNumber.next,
        alignOpenGraphTitleDescription: true
    });
};
